import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DomainsPage as DomainsInner } from "./Domains";
import { TrackedNamesPage as NamesInner } from "./TrackedNames";

type Tab = "domains" | "names";

/** Merged Protections page. Two axes of "what Ventrin watches":
 *    - Domains: which AI surfaces get policy applied
 *    - Tracked Names: workspace-specific client/matter terms to anonymise
 *  Matches the Policies/Users pattern — single sidebar entry, sub-tabs. */
export function ProtectionsShell() {
  const location = useLocation();
  const navigate = useNavigate();

  const initial: Tab =
    location.pathname.endsWith("/tracked-names") || location.search.includes("tab=names")
      ? "names"
      : "domains";
  const [tab, setTab] = useState<Tab>(initial);

  function switchTab(next: Tab) {
    setTab(next);
    const base = "/protections";
    navigate(next === "names" ? `${base}?tab=names` : base, { replace: true });
  }

  return (
    <>
      <div className="sg-subnav">
        <button
          type="button"
          className={`sg-subnav-item${tab === "domains" ? " active" : ""}`}
          onClick={() => switchTab("domains")}
        >
          Domains
        </button>
        <button
          type="button"
          className={`sg-subnav-item${tab === "names" ? " active" : ""}`}
          onClick={() => switchTab("names")}
        >
          Tracked Names
        </button>
      </div>
      {tab === "domains" ? <DomainsInner /> : <NamesInner />}
    </>
  );
}
